import { defineStore } from 'pinia';
import type { LatLng } from '~/util/distance';
import { useGlobalContentStore } from '~/store/globalContent';

export type UserLocation = LatLng & { label: string };
type StoredLocation = UserLocation & { country?: string };

const STORAGE_KEY = 'userLocation';

export const useLocationStore = defineStore('locationStore', {
  state: () => ({
    location: null as UserLocation | null,
    loaded: false,
  }),
  actions: {
    load() {
      if (this.loaded || !import.meta.client) {
        return;
      }
      this.loaded = true;
      try {
        const raw = localStorage.getItem(STORAGE_KEY);
        const stored = raw ? JSON.parse(raw) as StoredLocation : null;
        if (stored && stored.country === useGlobalContentStore().getCountryCode) {
          this.location = stored;
        }
        else if (stored) {
          localStorage.removeItem(STORAGE_KEY);
        }
      } catch {
        this.location = null;
      }
    },
    setLocation(location: UserLocation) {
      this.location = location;
      this.loaded = true;
      try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...location, country: useGlobalContentStore().getCountryCode }));
      } catch {
        // storage can be blocked, the location then only lives for this page view
      }
    },
    clear() {
      this.location = null;
      try {
        localStorage.removeItem(STORAGE_KEY);
      } catch {
        // see setLocation
      }
    },
  },
});
